import { render, staticRenderFns } from "./PatientLocationDropdown.vue?vue&type=template&id=0d70bbfb&scoped=true&"
import script from "./PatientLocationDropdown.vue?vue&type=script&lang=js&"
export * from "./PatientLocationDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d70bbfb",
  null
  
)

export default component.exports